import axios from 'axios';
import { BASE_API } from '../../axios';
import { TokenStorage } from '../../utils/cookieStorage';
import { sessionManager } from '../../utils/sessionManager';

// Separate axios instance for /api/documents (no /api/V1 prefix)
const docsAxios = axios.create({
  baseURL: BASE_API,// + '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

docsAxios.interceptors.request.use((config) => {
  const token = TokenStorage.getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.method !== 'get') {
    const csrfToken = sessionStorage.getItem('csrf_token');
    if (csrfToken) {
      config.headers['x-csrf-token'] = csrfToken;
    }
  }
  return config;
});

docsAxios.interceptors.response.use(
  (response) => {
    sessionManager.extendSession();
    return response;
  },
  (error) => Promise.reject(error)
);

export const fetchDocuments = (params = {}) => {
  return docsAxios.get('/documents', { params });
};

export const createDocument = ({ title, pacsOrdId = undefined, templateId = undefined, type = undefined }) => {
  return docsAxios.post('/documents', { title, pacsOrdId, templateId, type });
};

export const fetchTemplates = (params) => {
  return docsAxios.post('/template-list-oodocs', params || {});
};

export const getEditorConfig = (docId, mode = 'edit') => {
  return docsAxios.get(`/documents/config/${docId}`, { params: { mode } });
};

export const downloadDocument = async (docId, filename) => {
  const response = await docsAxios.get(`/documents/download/${docId}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(response.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'document.docx';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadDocumentBlob = async (docId) => {
  const response = await docsAxios.get(`/documents/download/${docId}`, {
    responseType: 'blob',
  });
  return response.data;
};

export const updateDocumentStatus = (docId, status) => {
  return docsAxios.patch(`/documents/${docId}/status`, { status });
};

export const deleteDocument = (docId) => {
  return docsAxios.delete(`/documents/${docId}`);
};

export const copyDocument = ({ sourceDocumentId, pacsOrdId, title }) => {
  return docsAxios.post('/documents/copy', { sourceDocumentId, pacsOrdId, title });
};

export const getTemplateDownloadUrl = async (templateId) => {
  const res = await docsAxios.get(`/template-url-oodocs/${templateId}`);
  return res.data?.data?.fileUrl || null;
};

export const applyTemplateToDocument = (docId, templateId, action = 'replace') => {
  return docsAxios.post(`/documents/${docId}/apply-template`, { templateId, action });
};

export const forceSaveDocument = (docId) => {
  return docsAxios.post(`/documents/${docId}/forcesave`);
};

export const downloadDocumentPdf = async (docId) => {
  const response = await docsAxios.get(`/documents/${docId}/pdf`, {
    responseType: 'blob',
  });
  return response.data;
};
